module.exports = __webpack_public_path__ + "resources/default_2.a706b3d8024464b4.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/post-welfare-v2/img/default_2.png
// module id = 764
// module chunks = 0 2